import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';

function* getWorldCup(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    oldestFirst: action.oldestFirst,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'widgets', 'getHeaderCorriere', urlParams);
    yield put({ type: types.GET_WORLD_CUP_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_WORLD_CUP_ERROR, error });
  }
}

function* getWorlCupCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    yield put({
      type: types.GET_WORLD_CUP_CALENDAR_SUCCESS, data, urlParams, widgetId: action.widgetId,
    });
  } catch (error) {
    yield put({ type: types.GET_WORLD_CUP_CALENDAR_ERROR, error });
  }
}

function* getWoldCupDayCalendar(action) {
  const urlParams = {
    sportId: action.urlParams.sportId,
    competitionId: action.urlParams.competitionId,
    phase: action.data.lastPhase.label,
    subPhase: action.data.lastSubPhase,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
    yield put({ type: types.GET_WORLD_CUP_DAY_CALENDAR_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_WORLD_CUP_DAY_CALENDAR_ERROR, error });
  }
}

function* watchGetWorldCup() {
  yield takeLatest(types.GET_WORLD_CUP_REQUEST, getWorldCup);
}

function* watchGetWorldCupCalendar() {
  yield takeEvery(types.GET_WORLD_CUP_CALENDAR_REQUEST, getWorlCupCalendar);
}

function* watchGetWoldCupDayCalendar() {
  yield takeEvery(types.GET_WORLD_CUP_CALENDAR_SUCCESS, getWoldCupDayCalendar);
}

export default [
  watchGetWorldCup,
  watchGetWorldCupCalendar,
  watchGetWoldCupDayCalendar,
];



// WEBPACK FOOTER //
// ./src/sagas/worldCup.js